<div class="controls-container">
    <div class="controls-header">Expander</div>
    
    <pm-expander [style.padding.px]="10" CaretAlignment="left">
        <div expander-header>Header</div>
        <div expander-body 
                [style.padding.px]="40" 
                [style.background-color]="'#57B0FE'"
                [style.margin.px]="5"
                [style.border-radius.px]="2"
                [style.color]="'white'">
                Expander Body
        </div>
    </pm-expander>
    
    <!-- <pm-properties [Item]="BreadcrumbControl"></pm-properties> -->
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/expander/expander.html